(function(angular) {
    'use strict';

    var chargeCaptureDesktopFeature = 'ChargeCaptureDesktopTile';

    angular.module('aprima-provider-api').factory('ChargeCaptureRepository', [
        '$q',
        'AprimaRestangular',
        'MetadataRepository',
        'ServerInfoRepository',
        ChargeCaptureRepository,
    ]);


    function ChargeCaptureRepository(
        $q,
        AprimaRestangular,
        MetadataRepository,
        ServerInfoRepository
    ) {
        var service = {
            getProviderChargeCaptures: getProviderChargeCaptures,
            getChargeCapture: getChargeCapture,
            getChargeCaptureMetadata: getChargeCaptureMetadata,
            createChargeCapture: createChargeCapture,
            editChargeCapture: editChargeCapture,
            removeChargeCapture: removeChargeCapture,
        };

        return service;


        function getProviderChargeCaptures(providerUid) {
            if(!ServerInfoRepository.isFeatureSupported(chargeCaptureDesktopFeature)) {
                return $q.when([]);
            }


            var result = AprimaRestangular.get()
                .one('chargecaptures/provider', providerUid)
                .get();

            return result;
        }

        function getChargeCapture(patientUid, chargeCaptureUid) {
            if(!ServerInfoRepository.isFeatureSupported(chargeCaptureDesktopFeature)) {
                // call older endpoint that only accepts patientUid
                var oldResult = AprimaRestangular.get()
                    .one('chargecapture', patientUid)
                    .get();

                return oldResult;
            }


            // call newer endpoint that accepts patientUid and chargeCaptureUid
            var newResult = AprimaRestangular.get()
                .one('chargecapture/patient', patientUid)
                .customGET('chargecaptureid', {
                    chargeCaptureId: chargeCaptureUid,
                });

            return newResult;
        }

        function getChargeCaptureMetadata($scope) {
            var result =  MetadataRepository.getMetadata('createchargecapture', $scope);

            return result;
        }

        function createChargeCapture(command) {
            var result =  AprimaRestangular.get()
                .all('chargecapture')
                .post(command);

            return result;
        }

        function editChargeCapture(patientUid, command) {
            var result =  AprimaRestangular.get()
                .one('chargecapture')
                .customPUT(command);

            return result;
        }

        function removeChargeCapture(chargeCaptureUid) {
            if(!ServerInfoRepository.isFeatureSupported(chargeCaptureDesktopFeature)) {
                return $q.reject('Removing a eMDs Round is not supported with this server version.');
            }

            var result =  AprimaRestangular.get()
                .one('chargecapture/remove', chargeCaptureUid)
                .get();

            return result;
        }
    }

})(window.angular);
